/**
* This is a TypeGen auto-generated file.
* Any changes made to this file will be lost when the file is regenerated.
*/

import {Observable} from "rxjs";
import {Injectable, Injector} from "@angular/core";
import {HttpEvent} from "@angular/common/http";
import {ApiServiceBase} from "../../api-service-base";
import {RestoreTrainingRoomRequest} from "../model/restore-training-room-request";
import {SuccessResponse} from "../model/success-response";

@Injectable({
    providedIn: "root",
})
export class SimRestorePointService extends ApiServiceBase {
	constructor(injector: Injector) {
        super(injector);
	}
    public createRestorePointForAcl() {
        return super.post<boolean>(`/api/RestorePoint/CreateRestorePointForAcl`, {});
    }

    public createRestorePointForTrainingRooms() {
        return super.post<boolean>(`/api/RestorePoint/CreateRestorePointForTrainingRooms`, {});
    }

    public restoreAcl() {
        return super.post<SuccessResponse>(`/api/RestorePoint/RestoreAcl`, {});
    }

    public restoreTrainingRoom(request: RestoreTrainingRoomRequest) {
        return super.post<SuccessResponse>(`/api/RestorePoint/RestoreTrainingRoom`, request);
    }

    public restoreTrainingRooms() {
        return super.post<SuccessResponse>(`/api/RestorePoint/RestoreTrainingRooms`, {});
    }
}